export default "__VITE_ASSET__DhxZLaHR__"